// Module
var code = `<div data-bind="css: question.cssClasses.selectWrapper">
  <!-- ko ifnot: question.isReadOnly -->
  <div data-bind="css: question.getControlClass(),
  click: click, 
  event: { keyup: keyup },
  attr: { 
    id: question.inputId, 
    required: question.isRequired, 
    tabindex: question.isInputReadOnly ? undefined : 0,
    disabled: question.isInputReadOnly,
    role: question.ariaRole,
    'aria-required': question.ariaRequired, 
    'aria-label': question.ariaLabel, 
    'aria-invalid': question.ariaInvalid, 
    'aria-describedby': question.ariaDescribedBy 
  },">
    <div data-bind="css: question.cssClasses.controlValue">
      <!-- ko if: question.locReadOnlyText -->
      <!-- ko template: { name: 'survey-string', data: question.locReadOnlyText } -->
      <!-- /ko -->
      <!-- /ko -->
    </div>
    <!-- ko if: (question.allowClear && question.cssClasses.cleanButtonIconId) -->
    <div data-bind="css: question.cssClasses.cleanButton, click: clear, visible: !question.isEmpty() ">
      <!-- ko component: { name: 'sv-svg-icon', params: { css: question.cssClasses.cleanButtonSvg, iconName: question.cssClasses.cleanButtonIconId, size: 'auto', title: question.clearCaption } } -->
      <!-- /ko -->
    </div>
    <!-- /ko -->
  </div>
  <!-- ko component: { name: "sv-popup", params: { model: model.popupModel }} -->
  <!-- /ko -->
  <!-- /ko -->
  <!-- ko if: question.isReadOnly -->
  <div disabled="disabled" data-bind="css: question.getControlClass(), attr: { id: question.inputId }, ">
    <!-- ko if: question.locReadOnlyText -->
    <!-- ko template: { name: 'survey-string', data: question.locReadOnlyText } -->
    <!-- /ko -->
    <!-- /ko -->
  </div>
  <!-- /ko -->
</div>`;
// Exports
export default code;